<div class="page" [nbSpinner]="loading">
  <div class="header" *ngIf="connector as c">
    <div>
      <div class="al-page-title">
        <a
          class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
          routerLink="/agent-setup/mcp"
          [attr.aria-label]="'buttons.back' | translate"
          [nbTooltip]="'buttons.back' | translate"
          nbTooltipPlacement="right"
        ><span class="al-relief-glyph" aria-hidden="true"></span></a>
        <h2>{{ c.name }}</h2>
      </div>
      <p class="subtitle">
        <code>{{ c.server_url }}</code>
        · {{ "pages.mcp.transport." + c.transport | translate }}
        · {{ "pages.mcp.auth." + c.auth_type | translate }}
        <span *ngIf="c.server_name"> · {{ c.server_name }} {{ c.server_version }}</span>
      </p>
    </div>
  </div>

  <nb-card *ngIf="connector as c" [nbSpinner]="busy">
    <nb-card-body>
      <!-- Status and the one thing to do next. -->
      <section class="tile-flat status">
        <header class="tile-flat__header">
          <h5>{{ "pages.mcp.detail.statusTitle" | translate }}</h5>
        </header>

        <p class="state" [ngClass]="c.is_active ? 'is-on' : 'is-off'">
          {{ (c.is_active ? "pages.mcp.status.active" : autoDisabled ? "pages.mcp.status.autoDisabled" : "pages.mcp.status.inactive") | translate }}
        </p>
        <p class="hint" *ngIf="c.disabled_reason && !c.is_active">{{ c.disabled_reason }}</p>

        <p class="hint" *ngIf="c.acknowledged_at">
          {{ "pages.mcp.detail.acknowledgedAt" | translate: { date: (c.acknowledged_at | date: "dd.MM.yyyy HH:mm") } }}
          <span *ngIf="!c.acknowledgement_current" class="warn">— {{ "pages.mcp.detail.ackOutdated" | translate }}</span>
        </p>
        <p class="hint" *ngIf="!c.acknowledged_at">{{ "pages.mcp.detail.notAcknowledged" | translate }}</p>

        <div class="actions">
          <button nbButton size="small" status="basic" type="button" (click)="editConnection()"
            [nbTooltip]="'pages.mcp.tooltips.editConnection' | translate">
            <nb-icon icon="edit-outline"></nb-icon>{{ "pages.mcp.detail.editConnection" | translate }}
          </button>
          <button nbButton size="small" status="basic" type="button" (click)="rediscover()"
            [nbTooltip]="'pages.mcp.tooltips.rediscover' | translate">
            <nb-icon icon="refresh-outline"></nb-icon>{{ "pages.mcp.detail.rediscover" | translate }}
          </button>
          <button nbButton size="small" status="basic" type="button" (click)="openAcknowledge()"
            [nbTooltip]="'pages.mcp.tooltips.acknowledge' | translate"
            *ngIf="!c.acknowledgement_current">
            <nb-icon icon="shield-outline"></nb-icon>{{ "pages.mcp.detail.acknowledge" | translate }}
          </button>
          <button nbButton size="small" status="primary" type="button" (click)="activate()"
            *ngIf="!c.is_active" [disabled]="!c.acknowledgement_current || !enabledCount"
            [nbTooltip]="(!c.acknowledgement_current ? 'pages.mcp.detail.activateNeedsAck' : 'pages.mcp.detail.activateHint') | translate">
            {{ "pages.mcp.detail.activate" | translate }}
          </button>
          <button nbButton size="small" status="basic" class="btn-caution" type="button" (click)="deactivate()" *ngIf="c.is_active"
            [nbTooltip]="'pages.mcp.tooltips.deactivate' | translate">
            {{ "pages.mcp.detail.deactivate" | translate }}
          </button>
        </div>

        <p class="hint">
          {{ "pages.mcp.detail.usage" | translate: { calls: c.calls_30d, failed: c.failed_calls_30d, agents: c.assigned_bot_ids.length } }}
        </p>
        <p class="hint">
          {{ "pages.mcp.detail.limits" | translate: { timeout: c.timeout_seconds, calls: c.max_calls_per_turn, chars: c.max_result_chars, failures: autoDisableAfter } }}
        </p>
      </section>

      <section class="tile-flat">
        <header class="tile-flat__header tools-head">
          <h5>{{ "pages.mcp.detail.toolsTitle" | translate: { enabled: enabledCount, total: c.tools.length } }}</h5>
          <div class="tools-head__actions" *ngIf="c.tools.length">
            <button nbButton size="small" status="basic" type="button" (click)="setAllTools(true)"
              [disabled]="busy || enabledCount === availableCount"
              [nbTooltip]="'pages.mcp.tooltips.enableAll' | translate">
              <nb-icon icon="checkmark-square-2-outline"></nb-icon>{{ "pages.mcp.detail.enableAll" | translate }}
            </button>
            <button nbButton size="small" status="basic" type="button" (click)="setAllTools(false)"
              [disabled]="busy || enabledCount === 0"
              [nbTooltip]="'pages.mcp.tooltips.disableAll' | translate">
              <nb-icon icon="square-outline"></nb-icon>{{ "pages.mcp.detail.disableAll" | translate }}
            </button>
          </div>
        </header>
        <p class="hint">{{ "pages.mcp.detail.toolsHint" | translate }}</p>

        <p class="hint" *ngIf="!c.tools.length">{{ "pages.mcp.detail.noTools" | translate }}</p>

        <ul class="tools">
          <li *ngFor="let tool of c.tools; trackBy: trackTool" [class.is-removed]="tool.removed">
            <div class="tool-head">
              <nb-toggle
                [checked]="tool.is_enabled"
                [disabled]="tool.removed"
                [nbTooltip]="'pages.mcp.tooltips.toolToggle' | translate"
                (checkedChange)="toggleTool(tool, $event)"
              ></nb-toggle>
              <code class="tool-name" [nbTooltip]="'pages.mcp.tooltips.agentToolName' | translate">{{ tool.agent_tool_name }}</code>
              <span class="badge badge--warn" *ngIf="tool.description_changed || tool.schema_changed">
                {{ "pages.mcp.detail.changedAtServer" | translate }}
              </span>
              <span class="badge" *ngIf="tool.removed">{{ "pages.mcp.detail.removed" | translate }}</span>
            </div>

            <!-- The approved description is what the model obeys. -->
            <div class="form-field">
              <label class="label">
                {{ "pages.mcp.detail.descriptionEffective" | translate }}
                <nb-icon icon="question-mark-circle-outline" class="hint-icon"
                  nbPopover="{{ 'pages.mcp.tooltips.descriptionEffective' | translate }}" nbPopoverTrigger="hover"></nb-icon>
              </label>
              <textarea nbInput fullWidth rows="3" [(ngModel)]="descDraft[tool.id]" [disabled]="tool.removed"></textarea>
              <div class="row-actions" *ngIf="descDirty(tool)">
                <button nbButton size="tiny" status="primary" type="button" (click)="saveDescription(tool)">
                  {{ "buttons.save" | translate }}
                </button>
              </div>
            </div>

            <div class="drift" *ngIf="tool.description_changed || tool.schema_changed">
              <span class="label">{{ "pages.mcp.detail.serverNow" | translate }}</span>
              <p *ngIf="tool.description_changed">{{ tool.description_server }}</p>
              <p *ngIf="tool.schema_changed">{{ "pages.mcp.detail.schemaChanged" | translate }}</p>
              <button nbButton size="tiny" status="basic" type="button" (click)="acceptServerVersion(tool)"
                [nbTooltip]="'pages.mcp.tooltips.acceptServerVersion' | translate">
                {{ "pages.mcp.detail.acceptServerVersion" | translate }}
              </button>
            </div>

            <details>
              <summary>{{ "pages.mcp.detail.schemaAndTest" | translate }}</summary>
              <pre class="schema">{{ schemaText(tool) }}</pre>
              <div class="form-field">
                <label class="label">
                  {{ "pages.mcp.detail.arguments" | translate }}
                  <nb-icon icon="question-mark-circle-outline" class="hint-icon"
                    nbPopover="{{ 'pages.mcp.tooltips.arguments' | translate }}" nbPopoverTrigger="hover"></nb-icon>
                </label>
                <textarea nbInput fullWidth rows="4" class="mono" data-enter-ignore [(ngModel)]="argsDraft[tool.id]"></textarea>
                <div class="row-actions">
                  <button nbButton size="tiny" status="basic" type="button" [disabled]="tool.removed || dryRunning[tool.id]"
                    [nbSpinner]="!!dryRunning[tool.id]" (click)="dryRun(tool)"
                    [nbTooltip]="'pages.mcp.detail.dryRunHint' | translate">
                    {{ "pages.mcp.detail.dryRun" | translate }}
                  </button>
                </div>
              </div>
              <ng-container *ngIf="dryResult[tool.id] as res">
                <p class="hint warn" *ngIf="isError(res)">{{ res.error }}</p>
                <ng-container *ngIf="!isError(res)">
                  <p class="hint">
                    {{ (res.ok ? "pages.mcp.detail.dryOk" : "pages.mcp.detail.dryFailed") | translate: { ms: res.duration_ms, kind: res.error_kind || "" } }}
                    <span *ngIf="res.message"> — {{ res.message }}</span>
                  </p>
                  <pre class="result" *ngIf="res.result">{{ res.result }}</pre>
                </ng-container>
              </ng-container>
            </details>
          </li>
        </ul>
      </section>
    </nb-card-body>
  </nb-card>
</div>
